import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SharedService {

  private dataSubject = new BehaviorSubject<string>('');
  private readonly storageClearedSubject = new Subject<void>();

  /** Emits after the session storage is cleared (every logout path), so session state can be torn down. */
  readonly storageCleared$ = this.storageClearedSubject.asObservable();

  setData(data: string) {
    this.dataSubject.next(data);
  }

  getData() {
    return this.dataSubject.asObservable();
  }

  getValue(key: string): any {
    return localStorage.getItem(key);
  }

  setValue(key: string, value: string): void {
    localStorage.setItem(key, value);
  }
  
  removeValue(key: string): void {
    localStorage.removeItem(key);
  }

  clearStorage(): void {
    localStorage.clear();
    sessionStorage.removeItem('collectx_admin_xsrf');
    this.storageClearedSubject.next();
  }
}